const brlFormatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
const brlNoCents = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export function brl(value: number): string {
  const rounded = Math.round(value * 100) / 100;
  return brlFormatter.format(rounded === 0 ? 0 : rounded);
}

/** "R$ 290" — teto redondo e média do retrospecto, sem centavos (formatCurrencyNoCents do app). */
export function brl0(value: number): string {
  return brlNoCents.format(Math.round(value));
}

/** "R$ 5,2 mil" pra eixo de gráfico. */
export function brlCompact(value: number, bare = false): string {
  const abs = Math.abs(value);
  const prefix = `${value < 0 ? '-' : ''}${bare ? '' : 'R$ '}`;
  if (abs >= 1_000_000) return `${prefix}${(abs / 1_000_000).toLocaleString('pt-BR', { maximumFractionDigits: 1 })} mi`;
  if (abs >= 1000) return `${prefix}${(abs / 1000).toLocaleString('pt-BR', { maximumFractionDigits: 1 })} mil`;
  return bare ? Math.round(value).toLocaleString('pt-BR') : brlNoCents.format(value);
}

const MONTHS_LONG = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
const MONTHS_SHORT = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
const WEEKDAYS = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'];

/** "2026-09" → "setembro de 2026" */
export function monthLong(ym: string): string {
  const [y, m] = ym.split('-').map(Number);
  return `${MONTHS_LONG[m - 1]} de ${y}`;
}

/** "2026-09" → "set" (ou "set/26" se pedir ano) */
export function monthShort(ym: string, withYear = false): string {
  const [y, m] = ym.split('-').map(Number);
  return withYear ? `${MONTHS_SHORT[m - 1]}/${String(y).slice(2)}` : MONTHS_SHORT[m - 1];
}

/** "2026-09-04" → "4 de setembro, quinta" */
export function dayLong(iso: string): string {
  const [y, m, d] = iso.split('-').map(Number);
  const date = new Date(y, m - 1, d);
  return `${d} de ${MONTHS_LONG[m - 1]}, ${WEEKDAYS[date.getDay()]}`;
}

/** "2026-09-04" → "04 de set" (o dayMonth do app, lib/dateLocale.ts) */
export function dayMon(iso: string): string {
  const [, m, d] = iso.split('-');
  return `${d} de ${MONTHS_SHORT[Number(m) - 1]}`;
}

/** "2026-09-04" → "04/09" */
export function dayShort(iso: string): string {
  const [, m, d] = iso.split('-');
  return `${d}/${m}`;
}

export function addMonths(ym: string, delta: number): string {
  const [y, m] = ym.split('-').map(Number);
  const idx = y * 12 + (m - 1) + delta;
  const ny = Math.floor(idx / 12);
  const nm = (idx % 12) + 1;
  return `${ny}-${String(nm).padStart(2, '0')}`;
}

export function todayMonth(): string {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
}

/** Só a primeira letra maiúscula ("setembro de 2026" → "Setembro de 2026"). */
export function cap(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function pct(part: number, total: number): number {
  if (total <= 0) return 0;
  return Math.round((part / total) * 100);
}
